module.exports = __webpack_public_path__ + "imgs/leafwell-logo-black.c807e1b4814f40dc49382e0b46b409fa.png";